export function useCurrencyFormaterFromCents(price?: number | null): string {
  const safePrice = typeof price === 'number' && !isNaN(price) ? price : 0
  return safePrice.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
}
